import axios from "axios";
import { dcisBaseUrl } from "../helpers/constants";

export const signIn = ({ email, password }) => {
  return axios.post(`${dcisBaseUrl}/v1/api/users/signIn/utm`, {
    email: email,
    password: password,
  });
};

export const createUser = (data) => {
  // console.log(data)
  return axios.post(`${dcisBaseUrl}/v1/api/users/addUser`, data);
};

export const OtpToEmail = ({ email }) => {
  return axios.patch(`${dcisBaseUrl}/v1/api/users/sendOtp`, {
    email
  })
}


// verify otp
export const verifyOtp = ({ email, otp }) => {
  return axios.post(`${dcisBaseUrl}/v1/api/users/verifyOtp/${email}`, {
    email: email,
    userOtp: otp,
  });
}

export const changePasswordApi = ({ payload, token }) => {
  return axios.patch(`${dcisBaseUrl}/v1/api/users/changePassword`, payload, {
    headers: { "x-access-token": token }
  })
}

export const forgetPassword = ({ payload, token }) => {
  return axios.patch(`${dcisBaseUrl}/v1/api/users/forgetPassword`, payload, {
    headers: { "x-access-token": token },
  })
}

export const addPilot = ({ token, data }) => {
  return axios.post(`${dcisBaseUrl}/v1/api/users/utm-user`, data,
    {
      headers: { "x-access-token": token }
    })
}

export const getAllPilots = (token) => {
  return axios.get(`${dcisBaseUrl}/v1/api/users/utm-user`, {
    headers: { "x-access-token": token },
  });
};

export const verifyToken = ({ token }) => {
  return axios.get(`${dcisBaseUrl}/v1/api/users/verify`, {
    headers: {
      "x-access-token": `${token}`,
    },
  });
};

export const getFlightReportsData = () => {
  return axios.get(`${dcisBaseUrl}/v1/api/website/flight-reports`);
}

export const deletePilot = ({ token, userId }) => {
  return axios.delete(`${dcisBaseUrl}/v1/api/users/delete/${userId}`, {
    headers: {
      "x-access-token": token
    }
  })
}

